import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const categoryApi = createApi({
  reducerPath: "categoriesApi", // ── Changed: "category" → "categoriesApi" (consistent naming)
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}users/categories`, // ── Changed: base BACKEND_API_URL → scoped to users/categories
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Categories"], // ── Changed: "Category" → "Categories" (plural, consistent)
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: ({ page = 1, limit = 10, search = "", status = "" }) => {
        // ── Changed: hardcoded `limit=10` → dynamic params (was ignoring all filters)
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
        });

        if (search) params.append("search", search);
        if (status !== "") params.append("status", status);

        return `?${params.toString()}`;
      },
      providesTags: ["Categories"],
    }),

    createCategory: builder.mutation({
      query: (formData) => ({
        url: "/", // ── Changed: full path → relative (baseUrl handles prefix)
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Categories"],
    }),

    getCategoryDetail: builder.query({
      query: (id) => `/${id}`, // ── Changed: full path → relative
      providesTags: (result, error, id) => [{ type: "Categories", id }], // ── Changed: specific tag with id
    }),

    updateCategoryDetails: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`, // ── Changed: full path → relative
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Categories"],
    }),

    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/${id}`, // ── Changed: full path → relative
        method: "DELETE",
      }),
      invalidatesTags: ["Categories"],
    }),

    toggleCategoryStatus: builder.mutation({
      // ── Changed: changeCategoryStatus → toggleCategoryStatus (matches service pattern)
      query: (id) => ({
        url: `/${id}/status`, // ── Changed: full path → relative, removed unused body
        method: "PATCH",
      }),
      invalidatesTags: ["Categories"],
    }),

    // ── Added: export endpoint matching servicesApi pattern ──
    exportCategories: builder.query({
      query: ({ search = "", status = "" }) => {
        const params = new URLSearchParams({ exportExcel: "true" });
        if (search) params.append("search", search);
        if (status !== "") params.append("status", status);
        return `?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useGetCategoryDetailQuery,
  useUpdateCategoryDetailsMutation,
  useDeleteCategoryMutation,
  useToggleCategoryStatusMutation, // ── Changed: useChangeCategoryStatusMutation → useToggleCategoryStatusMutation
  useLazyExportCategoriesQuery, // ── Added
} = categoryApi;
